import webrez1 from '../../../img/webrez/webrez-1.jpg'
import webrez2 from '../../../img/webrez/webrez-2.jpg'
import webrez3 from '../../../img/webrez/webrez-3.jpg'
import webrez4 from '../../../img/webrez/webrez-4.jpg'
import webrez5 from '../../../img/webrez/webrez-5.jpg'
import HelpDialog from './HelpDialog'
import styles from './HelpDialogs.module.scss'

const { subNumber } = styles

const WebRezHelpDialog = props => (
  <HelpDialog {...props} title="How to export guest data from WebRezPro">
    <section>
      <p>
        <span className={subNumber}>1.</span> Select{' '}
        <strong>Custom reservation report</strong> from side panel on left.
      </p>
      <img src={webrez1} alt="" />
    </section>
    <section>
      <p>
        <span className={subNumber}>2.</span>Select the date range and select{' '}
        <strong>Checkins & checkouts during selected dates</strong> from radio buttons
      </p>
      <img src={webrez2} alt="" />
    </section>
    <section>
      <p>
        <span className={subNumber}>3.</span>Select the <strong>All reservations</strong>{' '}
        on both Reservation parameters and Miscellaneous.
      </p>
      <img src={webrez3} alt="" />
    </section>
    <section>
      <p>
        <span className={subNumber}>4.</span>Just select{' '}
        <strong>Itemize reservations</strong> on Choose Data view{' '}
      </p>
      <img src={webrez4} alt="" />
    </section>
    <section>
      <p>
        <span className={subNumber}>5.</span>Select <strong>MS Excel</strong> from from
        Choose Output Type and click <strong>Generate Report</strong>
      </p>
      <img src={webrez5} alt="" />
    </section>
  </HelpDialog>
)

export default WebRezHelpDialog
